export default {
	RECOMMENDATION: 'Recommendation',
	EXCLUSION: 'Exclusion',
};
